import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare, faSigma } from '@fortawesome/pro-light-svg-icons';

library.add(faSquare, faSigma);
